import { render, staticRenderFns } from "./ListaRequisicaoProdutos.vue?vue&type=template&id=737c8a25&"
import script from "./ListaRequisicaoProdutos.vue?vue&type=script&lang=js&"
export * from "./ListaRequisicaoProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
